"use client";

import { createPath } from "@/service/routing/routing";
import slugify from "slugify";
import { Button } from "@/components/ui/button";
import { ExamPageTypeLink } from "@/components/exams/exam-page-type/link/exam-page-type-link";
import { ExamPageTypeTitle } from "@/components/exams/exam-page-type/exam-page-type-title";
import { ExamPageTypeContainer } from "@/components/exams/exam-page-type/exam-page-type-container";

export const ExamPageTypeTwoWay = ({ type }: { type: ExamType }) => {
  return (
    <div className="@container mx-auto max-w-[var(--content-width)]">
      <ExamPageTypeTitle
        showExamTypeSelector={true}
        type={type}
        title={`Biblioteka egzaminów ${type}`}
      />
      <ExamPageTypeContainer
        title={`${type} – baza pytań CEM oraz archiwalne egzaminy`}
        isH1={true}
      >
        <ExamPageTypeLink
          text={"Baza pytań CEM"}
          link={createPath("exam.page_type.database", {
            type: slugify(type, { lower: true }),
          })}
        />
        <ExamPageTypeLink
          text={"Archiwalne egzaminy"}
          link={createPath("exam.page_type.archive", {
            type: slugify(type, { lower: true }),
          })}
        />
      </ExamPageTypeContainer>

      <div className={"mt-4"}>
        <Button
          variant={"outline"}
          onClick={() => {
            const { pathname } = window.location;
            window.location.pathname = pathname.substring(
              0,
              pathname.lastIndexOf("/"),
            );
          }}
        >
          Wróć
        </Button>
      </div>
    </div>
  );
};
